import { useSelector } from "react-redux"
import { State } from "../../../../reducers"
import { getLogoEmpresa } from "../../../../actions/operaciones/operaciones.actions"
import { useEffect } from "react"
import { Pagination } from "../../../../components/Pagination"
import useFacturaExportacion from "../../../../actions/factura-exportacion.actions"
import TablaDocsAsociados from "../../../EmitirFactura/Components/GeneracionFactura/TablaDocsAsociados"
import { unirChipsJoin, unirChipsReturnFirst } from "../../../../utils/strings.utils"
import FilaCatalogoV2DTE from "../CamposV2/FilaCatalogoV2DTE";
import { ENDPOINTS } from "../../../../api/config";
import { esNormativaV2 } from "../../../../utils/normativa.utils";
import {TIPO_DTE, versionDteEmision} from '../../../../utils/version-documento.utils'
import {precioUnitarioNeto} from '../../../../utils/moneda.utils'
import {aMonto, montosDeLinea, redondear2} from '../../../../utils/calculo-dte'
import {lineaDeProductoExportacion} from '../../../../actions/factura-exportacion.actions'

import FilaDistritoEmisor from "../CamposV2/FilaDistritoEmisor";
export default function DTEFacturaExportacion (){
    const {formCliente, productos, response_QRcode, view, paises, recintos, inconterms, unidades, tableProductos} = useSelector((state: State) => state.facturaExportacion )
    const {datosUUID} = useSelector((state: State) => state.facturacion)
    const {datosEmisor, tipoDocumento, actividadesEconomicas, tipoPersona, condicionOperacion} = useSelector((state: State) => state.catalogos)
    const normativaV2 = esNormativaV2(datosEmisor)
    const {datos} = useSelector((state: State) => state.userLogin)
    const sucursal = formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente.sucursal)?.nombre
    const documento = formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente.sucursal)?.Documento?.find((doc: any) => doc.idsucursaldocumento === formCliente.serie)
    const serie = `${documento?.serie}-${documento?.numeroactual}`
    const {setTableProductos} = useFacturaExportacion()
    const {dataDocsAsociados} = useSelector((state: State) => state.documentos.otrosDocumentosAsociados)
    const datosReceptor = useSelector((state: State) => state.documentos.datosReceptor.form)

    const emisorGranContribuyente = datosEmisor?.tipoContribuyente === '1'
    const emisorJuridico = datosEmisor?.tipoEmpresa === '2'
    const seguro = aMonto(formCliente.seguro)
    const flete = aMonto(formCliente.flete)
    const descuentoGlobal = aMonto(formCliente.descuentoGlobal)
    const sumaOperaciones = redondear2(productos.reduce(
        (acumulado, producto) => acumulado + montosDeLinea(lineaDeProductoExportacion(producto)).venta, 0
    ))
    const subtotal = redondear2(sumaOperaciones + seguro + flete)
    const total = redondear2(subtotal - descuentoGlobal)

    useEffect(() => {
        setTableProductos(productos)
    }, [productos])


    return (
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout w-100' >
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell w-100' >
        <div className="card">
            <div className="dte-title">
                <label>{view === 'Previsualizacion' ? 'PREVISUALIZACIÓN DE ' : '' }DOCUMENTO TRIBUTARIO ELECTRÓNICO</label>
                <label>FACTURA EXPORTACIÓN</label>
            </div>
            <div className="separador" />
            <div className='dt-card-grid-2c-1r' style={{alignItems: 'center'}}>
                <div className='dt-card-2c-1r-no-border' style={{textAlign: 'center'}}>
                    <img alt="Logo" src={getLogoEmpresa()} className='logo-itprofis'/>
                </div>
                <div className='dt-card-2c-1r' style={{padding:"3% 0"}}>
                    <table className="dte-table">
                        <tr>
                            <td>Documento Tributario Electrónico Versión:</td>
                            <td>{versionDteEmision(TIPO_DTE.FACTURA_EXPORTACION, datosEmisor) || ''}</td>
                        </tr>
                        <tr>
                            <td>Código de Generación:</td>
                            <td>{datosUUID?.CodigoGeneracion}</td>
                        </tr>
                        <tr>
                            <td>Sucursal:</td>
                            <td>{sucursal}</td>
                        </tr>
                        <tr>
                            <td>Serie:</td>
                            <td>{serie}</td>
                        </tr>
                        <tr>
                            <td>Moneda:</td>
                            <td>USD - Dólar estadounidense</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div className='dt-card-grid-2c-1r'>
                {/* DATOS DEL RECEPTOR */}
                <div className='dt-card-2c-1r' style={{padding:"3% 0"}}>
                <div className='dt-center-content'>
                    <label className="dte-subsection-title">Receptor</label>
                    <table className="dte-table">
                        <tr><td>Nombre:</td><td>{formCliente?.nombre}</td></tr>
                        <tr><td>{`${tipoDocumento.find((doc) => doc.codigo === formCliente.tipoDocumento)?.valor}:`}</td><td>{formCliente?.noDocumento}</td></tr>
                        <tr><td>Tipo de persona:</td><td>{tipoPersona?.find((persona: any) => persona.codigo === formCliente?.persona)?.valor}</td></tr>
                        <tr><td>Actividad económica:</td><td>{actividadesEconomicas.find((actividad) => actividad.codigo === formCliente?.actividad)?.valor}</td></tr>
                        <tr><td>Dirección:</td><td>{formCliente?.direccion}</td></tr>
                        <tr><td>Teléfono celular:</td><td>{formCliente?.telefono || 'No indica'}</td></tr>
                        <tr><td>Correo electrónico:</td><td>{unirChipsReturnFirst(formCliente?.chipsEmail, formCliente?.email) || 'No indica'}</td></tr>
                        <tr><td>Envío de documento por correo electrónico a:</td><td>{unirChipsJoin(formCliente?.chipsEmail, formCliente?.email) || 'No indica'}</td></tr>
                    </table>
                </div>
                </div>
                {/* DATOS DEL EMISOR */}
                <div className='dt-card-2c-1r' style={{padding:"3% 0"}}>
                    <div className='dt-center-content'>
                    <label className="dte-subsection-title">Emisor</label>
                    <table className="dte-table">
                        <tr><td>Tipo de persona:</td><td>{datosEmisor?.desTipoEmpresa ?? ''}</td></tr>
                        <tr><td>Tipo de contribuyente:</td><td>{datosEmisor?.desContribuyente ?? ''}</td></tr>
                        <tr><td>Nombre del cliente:</td><td>{datosEmisor?.nombre}</td></tr>
                        <tr><td>Dirección:</td><td>{datosEmisor?.complemento}</td></tr>
                        <tr><td>Departamento:</td><td>{datosEmisor?.departamentonombre}</td></tr>
                        <tr><td>Municipio:</td><td>{datosEmisor?.municipionombre}</td></tr>
                        <FilaDistritoEmisor />
                        <tr><td>Giro:</td><td>{datosEmisor?.descactividad}</td></tr>
                        <tr><td>NIT:</td><td>{datosEmisor?.nit}</td></tr>
                        <tr><td>NRC:</td><td>{datosEmisor?.nrc}</td></tr>
                        <tr><td>Teléfono celular:</td><td>{datosEmisor?.telefono}</td></tr>
                        <tr><td>Correo electrónico:</td><td>{datosEmisor?.correo}</td></tr>
                    </table>
                </div>
                </div>
            </div>
            <div className="dte-section">
                <div className="dte-subsection">
                <label className="dte-subsection-title">Datos de exportación</label>
                    <table className="dte-table">
                        <tr><td>Régimen de exportación:</td><td>{formCliente.regimenExportacion}</td></tr>
                        {normativaV2 && <FilaCatalogoV2DTE endpoint = {ENDPOINTS.GET_TIPO_REGIMEN} etiqueta = 'Tipo de régimen' codigo = {formCliente.tipoRegimen}/>}
                        <tr><td>Recinto fiscal:</td><td>{recintos.find((recinto: any) => recinto.codigo === formCliente?.recintoFiscal)?.valor}</td></tr>
                        <tr><td>INCOTERMS:</td><td>{inconterms.find((doc: any) => doc.codigo === formCliente?.incoterms)?.valor}</td></tr>
                        <tr><td>País de exportación:</td><td>{paises?.find((pais: any) => pais.codigo === formCliente?.paisExportacion)?.valor}</td></tr>
                        {normativaV2 && formCliente.numDocumentoCompraTercero && formCliente.nombreCompraTercero &&
                            <>
                                <tr><td>Compra por cuenta de tercero, documento:</td><td>{formCliente.numDocumentoCompraTercero}</td></tr>
                                <tr><td>Compra por cuenta de tercero, nombre:</td><td>{formCliente.nombreCompraTercero}</td></tr>
                            </>
                        }
                    </table>
                </div>
                {/* <div className="dte-subsection">
                <label className="dte-subsection-title">Forma de pago</label>
                <table className="dte-table">
                        <tr><td>Condición de la operación:</td><td>{condicionOperacion.find((condicion: any) => condicion.codigo === formCliente?.condicion)?.valor || 'No indica'}</td></tr>
                        <tr><td>Forma de pago:</td><td>{formasPago.find((pago: any) => pago.codigo === formCliente?.formaPago)?.valor || 'No indica'}</td></tr>
                        <tr><td>Monto:</td><td>{parseFloat(formCliente?.montoFormaPago || '0')?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td></tr>
                    </table>
                </div> */}
            </div>

            {/* TABLA DE OTROS DOCUMENTOS RELACIONADOS */}
            {
            dataDocsAsociados.length > 0 && 
            (
                <div className="dte-section" style={{marginTop:"20px"}}>
                    <div className="dte-subsection">
                        <label className="dte-subsection-title">Otros documentos asociados</label>
                        <TablaDocsAsociados sinAcciones={true} />                    
                    </div>
                </div>
            )
            }

            <div className="tab-plane" style={{marginTop:"20px"}}>
                <div className="table-facturacion-resp">
                    <table className="table-main-responsive responsive-table-main td-left table-pointer">
                        <thead>
                            <tr>
                                <td>Cantidad</td>
                                <td>Unidad</td>
                                <td>Tipo</td>
                                <td>Descripción</td>
                                <td>Precio unitario</td>
                                <td>Descuento</td>
                                <td>Ventas gravadas</td>
                            </tr>
                        </thead>
                        <tbody>
                            {tableProductos.map((producto, index) => {
                                const precioUnitario = precioUnitarioNeto(producto.precio, false)
                                const {descuento, venta: gravadas} = montosDeLinea(lineaDeProductoExportacion(producto))

                                return(
                                <tr key={index}>
                                    <td data-label="Cantidad">{producto.cantidad}</td>
                                    <td data-label="Unidad">{unidades.find((unidad: any) => unidad.codigo === producto.unidadMedida)?.valor}</td>
                                    <td data-label="Tipo">{`${producto.servicio ? 'Servicio' : 'Producto'} ${producto.exento ? ' exento' : ''}`}</td>
                                    <td data-label="Descripción" style={{wordBreak:"break-all"}}>{<div dangerouslySetInnerHTML={{ __html: producto.descripcion }} />}</td>
                                    <td data-label="Precio unitario">{precioUnitario.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    <td data-label="Descuento">{isNaN(descuento) ? '$0.00' : descuento.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    <td data-label="Ventas gravadas">{!producto.exento ? (isNaN(gravadas) ? '$0.00' : gravadas.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})): '$0.00'}</td>
                                    
                                </tr>
                            )})}
                        </tbody>
                    </table>
                    </div>
                    <Pagination data = {productos} state = {(items: Array<any>) => setTableProductos(items)} items = {10}/>
                    <div className="cf-calculos-producto">
                        <table>
                            <tbody>
                                <tr className="cf-subtotal">
                                    <td>Suma de operaciones</td>
                                    <td>{sumaOperaciones.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Seguro</td>
                                    <td>{seguro.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Flete</td>
                                    <td>{flete.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Subtotal</td>
                                    <td>{subtotal.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Descuento global</td>
                                    <td>{descuentoGlobal.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-total">
                                    <td>Total</td>
                                    <td>{total.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            <div className='dt-card w-100 text-center' style={{padding: 0}}>
            {response_QRcode ? <div className='dt-card-grid-3c'>
              {response_QRcode && <div>
                <img src={response_QRcode} alt='qr' className='dt-img-qr'/>
              </div>}
              <div className='dt-card-2c-responsive'>
                <div className='detail'>
                  <label>Responsable por parte del Emisor:</label>
                  <label>{datos?.name}</label>
                </div>
                <div className='detail'>
                  <label>Responsable por parte del Receptor:</label>
                <label>{datosReceptor.nombre ? datosReceptor.nombre : formCliente?.nombre}</label>
                </div>
              </div>
              <div className='dt-card-2c-responsive'>
                <div className='detail'>
                  <label>{datos?.tipo_documento || 'N° de Documento'}:</label>
                  <label>{datos?.documento}</label>
                </div>
                <div className='detail'>
                  <label>{`${datosReceptor.nombreTipoDocumento ? `${datosReceptor.nombreTipoDocumento}` : tipoDocumento.find((doc) => doc.codigo === formCliente.tipoDocumento)?.valor}:`}</label>
                  <label>{datosReceptor.nombreTipoDocumento ? datosReceptor.numId : formCliente?.noDocumento}</label>
                </div>
              </div>
            </div> :
            <div className={'dt-card-grid-2c'}>
                <div className='detail'>
                  <label>Responsable por parte del Emisor:</label>
                  <label>{datos?.name}</label>
                </div>
                <div className='detail'>
                  <label>{datos?.tipo_documento || 'N° de Documento'}:</label>
                  <label>{datos?.documento}</label>
                </div>
                <div className='detail'>
                  <label>Responsable por parte del Receptor:</label>
                <label>{datosReceptor.nombre ? datosReceptor.nombre : formCliente?.nombre}</label>
                </div>
                <div className='detail'>
                  <label>{`${datosReceptor.nombreTipoDocumento ? `${datosReceptor.nombreTipoDocumento}` : tipoDocumento.find((doc) => doc.codigo === formCliente.tipoDocumento)?.valor}:`}</label>
                  <label>{datosReceptor.nombreTipoDocumento ? datosReceptor.numId : formCliente?.noDocumento}</label>
                </div>
            </div> }
            </div>
        </div>
        </div>
        </div>
    )
}